export default __webpack_public_path__ + "static/media/thinkrank.ab906823.png";